import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';

import sessionReducer from './SessionReducer';
import gameReducer from './GameReducer';
import organizationReducer from './OrganizationReducer';
import projectReducer from './ProjectReducer';
import shellReducer from './ShellReducer';
import analyticsReducer from './AnalyticsReducer';
import ormReducer from '../common/reducers/ormReducer';
const createRootReducer = (history) => {
  const { routerReducer } = createReduxHistoryContext({ history });

  return {
    session: sessionReducer,
    db: combineReducers({
      organization: organizationReducer,
      games: gameReducer,
      projects: projectReducer,
    }),
    router: routerReducer,
    shell: shellReducer,
    analytics: analyticsReducer,
    orm: ormReducer,
  };
};

export default createRootReducer;
